import React, { useEffect, useRef, useState } from 'react'; // تم إضافة useState هنا
import { ArrowRight, Play, X } from "lucide-react"; // تم إضافة أيقونة X للإغلاق
import { useTranslation } from "react-i18next"; 
import MeetOurTeam from '../../pages/aboutUs/meetOurTeam'; 
import { useNavigate } from "react-router-dom";
import cont1 from './assets/1.png';
import cont2 from './assets/2.png';
import cont3 from './assets/3.png';
import exploreVideo from './assets/explore.mp4';
import FacebookIcon from "../../icons/facebookIcon";
import InstagramIcon from "../../icons/instagramICon";
import xIcon from "../../icons/xIcon";
import LinkedinIcon from "../../icons/linkedinIcon";
import { MapPin, Phone, Mail } from 'lucide-react';

export default function MegtLogisticPage() {
  const canvasRef = useRef(null);
  const navigate = useNavigate();  
  const { t, i18n } = useTranslation();
  
  // حالة التحكم في فتح وإغلاق الـ Popup
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const lang = i18n.language || 'ar';
  const currentDir = lang === 'ar' ? 'rtl' : 'ltr';

  // تأثير الـ WebGL Canvas
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    function syncSize() {
      if (!canvas) return;
      const w = canvas.clientWidth || 1280;
      const h = canvas.clientHeight || 720;
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
      }
    }
    
    syncSize();
    window.addEventListener('resize', syncSize);

    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return;

    const vs = `
      attribute vec2 a_position;
      varying vec2 v_texCoord;
      void main() {
        v_texCoord = a_position * 0.5 + 0.5;
        gl_Position = vec4(a_position, 0.0, 1.0);
      }
    `;

    const fs = `
      precision highp float;
      varying vec2 v_texCoord;
      uniform float u_time;
      uniform vec2 u_resolution;

      float line(vec2 p, vec2 a, vec2 b, float width) {
          vec2 pa = p - a, ba = b - a;
          float h = clamp(dot(pa, ba) / dot(ba, ba), 0.0, 1.0);
          return smoothstep(width, 0.0, length(pa - ba * h));
      }

      void main() {
          vec2 uv = v_texCoord;
          vec3 color = vec3(0.0);
          float glow = 0.5 - length(uv - 0.5);
          color = vec3(0.1, 0.2, 0.5) * glow * 0.2;

          for(float i = 0.0; i < 8.0; i++) {
              float t = u_time * (0.1 + i * 0.05);
              vec2 start = vec2(fract(sin(i * 123.4) * 456.7), fract(cos(i * 567.8) * 890.1));
              vec2 end = vec2(fract(sin(i * 321.0) * 654.3), fract(cos(i * 987.6) * 210.9));
              float dash = fract(t + i * 0.1);
              vec2 pos = mix(start, end, dash);
              
              float l = line(uv, start, end, 0.001);
              float p = smoothstep(0.015, 0.0, length(uv - pos));
              
              color += l * vec3(0.1, 0.3, 0.8) * 0.5;
              color += p * vec3(0.9, 0.1, 0.1);
          }
          gl_FragColor = vec4(color, 0.6);
      }
    `;

    function cs(type, src) {
      const s = gl.createShader(type);
      if (!s) return null;
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return s;
    }

    const prog = gl.createProgram();
    const vertexShader = cs(gl.VERTEX_SHADER, vs);
    const fragmentShader = cs(gl.FRAGMENT_SHADER, fs);
    
    if (prog && vertexShader && fragmentShader) {
      gl.attachShader(prog, vertexShader);
      gl.attachShader(prog, fragmentShader);
      gl.linkProgram(prog);
      gl.useProgram(prog);
    }

    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);

    const pos = prog ? gl.getAttribLocation(prog, 'a_position') : -1;
    if (pos !== -1) {
      gl.enableVertexAttribArray(pos);
      gl.vertexAttribPointer(pos, 2, gl.FLOAT, false, 0, 0);
    }

    const uTime = prog ? gl.getUniformLocation(prog, 'u_time') : null;
    const uRes = prog ? gl.getUniformLocation(prog, 'u_resolution') : null;

    let animationFrameId;
    function render(t) {
      if (!gl || !canvas) return;
      gl.viewport(0, 0, canvas.width, canvas.height);
      if (uTime) gl.uniform1f(uTime, t * 0.001);
      if (uRes) gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      animationFrameId = requestAnimationFrame(render);
    }
    render(0);

    return () => {
      window.removeEventListener('resize', syncSize);
      cancelAnimationFrame(animationFrameId);
      if (gl && prog) {
        gl.deleteProgram(prog);
        gl.deleteBuffer(buf);
      }
    };
  }, []);

  return (
    <div className="bg-[#0e131e] text-[#dee2f2] antialiased overflow-x-hidden selection:bg-[#cd021b] selection:text-white w-full" dir={currentDir}>
      
      {/* 1. Hero Section */}
      <section className="relative min-h-screen xl:h-screen flex flex-col justify-center items-center overflow-hidden py-20 xl:py-0">
        <div className="absolute inset-0 z-0">
          <div className="w-full h-full bg-cover bg-center scale-105 animate-[pulse_10s_ease-in-out_infinite]" style={{ backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuDHDDyUBOzs5OVFsklju4RyxUFQR7hInbioPoaKwTBQLgi7ntygEICfX0iANLePeqHMPENJDkPkffQj_LDmNvbL9OD1UtNAWDD1_jEnFi2xRPX5MwcfSEdtz6BX3QfUHGpldZluLgb88elK93kyGITKfdmA0MZgeBnv3KQpK_EWGidb2zPIhfTk-078W_nClPXPYGtRP31zh6U1GZW4IafG_NTcLhrkLdTgjkK-YgK0s4VuXIDlZnGFrwkZX53gk3uOw0k4Jt53UdI')" }}></div>
          <div className="absolute inset-0 bg-[#0e131e]/50 bg-gradient-to-b from-transparent to-[#0e131e]/95"></div>
        </div>

        {/* Canvas Animation */}
        <div className="absolute inset-0 w-full h-full mix-blend-screen pointer-events-none z-10">
          <canvas ref={canvasRef} className="w-full h-full block"></canvas>
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-16 relative z-20 flex flex-col justify-between h-full w-full max-w-7xl py-12 xl:py-24 gap-12">
          <div className="max-w-4xl space-y-6 md:space-y-8 my-auto text-center lg:text-start">
            <h1 
              className="text-3xl sm:text-5xl lg:text-6xl xl:text-7xl leading-tight text-white font-bold tracking-tight"
              dangerouslySetInnerHTML={{ __html: t("homeContent.hero.title") }}
            />
            <p className={`text-base sm:text-lg lg:text-xl text-[#dee2f2]/90 max-w-2xl p-4 md:p-6 mx-auto lg:mx-0 ${lang === 'ar' ? 'border-r-4' : 'border-l-4'} border-[#cd021b] bg-black/10 backdrop-blur-sm rounded-r-sm`}>
              {t("homeContent.hero.description")}
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 pt-2">
              <button className="bg-[#cd021b] text-white px-6 sm:px-10 py-3.5 sm:py-4 rounded-lg font-semibold hover:bg-red-700 transition-all flex items-center gap-2 group w-full sm:w-auto justify-center" onClick={() => navigate('/services')}>
                {t("homeContent.hero.cta_services")}
                <ArrowRight className={`group-hover:translate-x-1 transition-all ${lang === 'ar' ? 'rotate-180 group-hover:-translate-x-1' : ''}`} />
              </button>
              <button className="backdrop-blur-xl bg-white/10 border border-white/10 text-white px-6 sm:px-10 py-3.5 sm:py-4 rounded-lg font-semibold hover:bg-white/20 transition-all w-full sm:w-auto justify-center" onClick={() => navigate('/contact-us')}>
                {t("homeContent.hero.cta_contact")}
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 w-full">
            <div className="backdrop-blur-xl bg-[#1b1f2b]/60 border border-white/10 p-4 sm:p-6 rounded-xl flex flex-col items-center border-t-2 border-[#cd021b]/50 text-center">
              <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cd021b]">+5000</span>
              <span className="text-xs sm:text-sm font-semibold text-[#c4c6d1] mt-1">{t("homeContent.hero.stat_shipments")}</span>
            </div>
            <div className="backdrop-blur-xl bg-[#1b1f2b]/60 border border-white/10 p-4 sm:p-6 rounded-xl flex flex-col items-center text-center">
              <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">+100</span>
              <span className="text-xs sm:text-sm font-semibold text-[#c4c6d1] mt-1">{t("homeContent.hero.stat_clients")}</span>
            </div>
            <div className="backdrop-blur-xl bg-[#1b1f2b]/60 border border-white/10 p-4 sm:p-6 rounded-xl flex flex-col items-center text-center">
              <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">+50</span>
              <span className="text-xs sm:text-sm font-semibold text-[#c4c6d1] mt-1">{t("homeContent.hero.stat_countries")}</span>
            </div>
            <div className="backdrop-blur-xl bg-[#1b1f2b]/60 border border-white/10 p-4 sm:p-6 rounded-xl flex flex-col items-center text-center">
              <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">+10</span>
              <span className="text-xs sm:text-sm font-semibold text-[#c4c6d1] mt-1">{t("homeContent.hero.stat_experience")}</span>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Features Showcase Section */}
      <section className="py-16 md:py-28 bg-white relative overflow-hidden text-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {/* Feature Cards */}
            <div className="relative h-64 rounded-xl overflow-hidden group shadow-md hover:shadow-xl transition-all">
              <img className="absolute inset-0 object-cover w-full h-full group-hover:scale-110 transition-transform duration-700" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAe1HFmDdJn0hp51gJOpvz8KLVgwC937nQpCgXvxtG4ytgHWd6Sd0ug7fUpoaofUJwde801ixTcf3yRGUkEH_Zjg6IsFzv7EW-Ev7FUP9N4nX3HA2N8BLG97oLoHbTTZVU8-Z_8AiNTZK-I2HHuC73_3idCO4GBDF2-OgAz4P9-NhGXDxZrccJLCNoc3H__OXt5rPq0xORRq5pkUTjj1H2aLO4kENjyQSQaf0A7mdCl9uSEJ8abpjCmR31QMSJrFqxtpJ3bOKfxSuk" alt={t("homeContent.features.precision_tag")}/>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent p-6 flex flex-col justify-end">
                <h4 className="text-xs font-bold text-[#ffb3ac] uppercase tracking-wider mb-1">{t("homeContent.features.precision_tag")}</h4>
                <p className="text-white font-semibold text-sm sm:text-base">{t("homeContent.features.precision_desc")}</p>
              </div>
            </div>
            <div className="relative h-64 rounded-xl overflow-hidden group shadow-md hover:shadow-xl transition-all">
              <img className="absolute inset-0 object-cover w-full h-full group-hover:scale-110 transition-transform duration-700" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAQfimNwSMITNJHPdguXlftdy97FS-qK5XYAX9vFIxLg6ygWE-VTbWP84eGruHyVLgv0EaCgplt0N2-F6WB9uH0EUQUpklAd9GBnOxkiyFut1MDy6l__8WnyY2rHGGRa-OcPrkJUp8zL0B2KkH0MLrzu6o0c3cltG7bcFnXJVN1MFcynoUJpcqtL4HjSIUxbWQMx6APbaBlsveu2CaCNcPJmjO-XAgOL125mkaKRGL6VLnGyoY213RTI-6erEnC_6Sw0IrfinhENc0" alt={t("homeContent.features.speed_tag")}/>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent p-6 flex flex-col justify-end">
                <h4 className="text-xs font-bold text-[#ffb3ac] uppercase tracking-wider mb-1">{t("homeContent.features.speed_tag")}</h4>
                <p className="text-white font-semibold text-sm sm:text-base">{t("homeContent.features.speed_desc")}</p>
              </div>
            </div>
            <div className="relative h-64 rounded-xl overflow-hidden group shadow-md hover:shadow-xl transition-all">
              <img className="absolute inset-0 object-cover w-full h-full group-hover:scale-110 transition-transform duration-700" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBdiyjNQdbimjxLrajBJvKjUSfViG4IkSFUCPjE_cVvIcKftUQZOvaCJfGYcCuIQBXpFIBs9Pd276Uvn1ZtA4ggcWp-BKuaVRyRCR8PQa_TWa4r66MB0epW3YVUulTA_Q8IxWk9ofGG1uzd_1cL5sFBLKRCbXblJJLiBOhXxgs-L2P-KAtEOlO-oQb5oVsNDCY-otv-rtGjkJ3jdTtF94oLWLg0PRKcYJMoqDzIVeynMChj4-af89IAy7fvff2zH-jXLo07vPLZAoY" alt={t("homeContent.features.capacity_tag")}/>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent p-6 flex flex-col justify-end">
                <h4 className="text-xs font-bold text-[#ffb3ac] uppercase tracking-wider mb-1">{t("homeContent.features.capacity_tag")}</h4>
                <p className="text-white font-semibold text-sm sm:text-base">{t("homeContent.features.capacity_desc")}</p>
              </div>
            </div>
            <div className="relative h-64 rounded-xl overflow-hidden group shadow-md hover:shadow-xl transition-all">
              <img className="absolute inset-0 object-cover w-full h-full group-hover:scale-110 transition-transform duration-700" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAxKZ7y-9SxSqrO39kRCpOrtbEVK2QUWg-xBl4zfKtQ5r4LloJ3ldv5l4jzcSvtx7G-Z61m7f9_zkDc54O-2pdTFxHzj7apGu1EjFU8zer0Py7gNTRyqnLIJtdw9wGlRdC3aRylsSi6rTUb1Oy2Paq5iBVfdRITJoP3uAQsIKc5vXu_aSUHfMtgMP8SHrJ6Jsv0ZUkP0wS1bjOviQDKNNOs7cynovHCU5Q9S39VnQutNmVFOVrqi2p-yr8uKm7GHSl4u2qobEiAFjQ" alt={t("homeContent.features.network_tag")}/>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent p-6 flex flex-col justify-end">
                <h4 className="text-xs font-bold text-[#ffb3ac] uppercase tracking-wider mb-1">{t("homeContent.features.network_tag")}</h4>
                <p className="text-white font-semibold text-sm sm:text-base">{t("homeContent.features.network_desc")}</p>
              </div>
            </div>
          </div>

          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 tracking-tight max-w-3xl mx-auto">
              {t("homeContent.features.headline")}
            </h2>
          </div>

          {/* Video Block */}
          <div className="relative rounded-2xl overflow-hidden bg-gray-50 border border-gray-100 p-2 md:p-3 aspect-video shadow-xl max-w-4xl mx-auto">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80&w=2070')] bg-cover bg-center rounded-xl overflow-hidden">
              {/* عند الضغط هنا يتم تعديل الـ State لفتح الفيديو */}
              <div 
                className="absolute inset-0 bg-black/40 flex items-center justify-center group cursor-pointer transition-colors duration-300 hover:bg-black/50"
                onClick={() => setIsVideoOpen(true)}
              >
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#cd021b] flex items-center justify-center text-white group-hover:scale-110 transition-all duration-300 shadow-2xl backdrop-blur-sm bg-opacity-95">
                  <Play className="w-8 h-8 md:w-10 md:h-10 ml-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. About Us Section */}
      <section className="py-16 md:py-28 bg-slate-50 text-slate-600" id="about">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="space-y-6">
              <h6 className="text-xs font-bold text-red-600 uppercase tracking-[0.2em]">{t("homeContent.about.tag")}</h6>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-950 leading-tight">{t("homeContent.about.title")}</h2>
              <p className="text-base sm:text-lg text-slate-600 leading-relaxed">{t("homeContent.about.desc")}</p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
                <div className="p-4 bg-white rounded-xl shadow-sm border border-slate-100">
                  <h5 className="text-lg font-bold text-blue-950 mb-2">{t("homeContent.about.feature_precision_title")}</h5>
                  <p className="text-slate-500 text-sm leading-relaxed">{t("homeContent.about.feature_precision_desc")}</p>
                </div>
                <div className="p-4 bg-white rounded-xl shadow-sm border border-slate-100">
                  <h5 className="text-lg font-bold text-blue-950 mb-2">{t("homeContent.about.feature_sustainability_title")}</h5>
                  <p className="text-slate-500 text-sm leading-relaxed">{t("homeContent.about.feature_sustainability_desc")}</p>
                </div>
              </div>
            </div>
            
            <div className="relative w-full max-w-md lg:max-w-none mx-auto">
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-red-600 opacity-10 rounded-full blur-3xl"></div>
              <img className="w-full aspect-[4/5] object-cover rounded-2xl shadow-2xl" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAdhAUnhx_g7dGOhp4rdEV4rwJHLmWo0IqLAuudiq4BtniegzSgeHOm-hXSFzkybf87wt_6S5hpwj3ryx8CPVphhWxeXF_ucigB0BJk1sutRvvQt_hUPVMLH4GqAvf6Qnrjfex-Zhks5pNfYd_1Xmn0iTKiXLHBgB2ss8ybk7Uq3pxatv8s1hiph20g6FOqA8HpI8gsqtJ0GCvdcNJ6QNuDjNdGs8b2oXmL8fdjxEhHUQVRA6XJ0W-24xQjPjI7xk5rgYSy94ziT1g" alt={t("homeContent.about.tag")}/>
              <div className={`absolute -bottom-6 ${lang === 'ar' ? '-left-6 border-r-4' : '-right-6 border-l-4'} backdrop-blur-md bg-white/80 p-6 md:p-8 rounded-xl hidden sm:block border-red-600 border border-white/30 shadow-lg`}>
                <span className="text-3xl md:text-4xl font-bold text-blue-950 block">99.9%</span>
                <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider mt-1 block">{t("homeContent.about.accuracy_rate")}</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16 md:mt-24">
            <div className="group overflow-hidden rounded-xl h-64 shadow-md">
              <img className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" src="https://lh3.googleusercontent.com/aida-public/AB6AXuD3eLMQE9boZvAdH21cRUWQyDSkMF77srSZnCa641peqmfXHXPFwck5r_rr8ym3LWPqCmyF358FblsptoV9cBxB4YrjGbARnprWS5KHD9TlCKaNDMFssN4d6BVvgQnIwIKmyDB5tR8oN286S7HHNfcolZ_878E-o5JfE8H7UO1kFd3vHdviY_lZtMB-CCCOCv6DUt7L93qKfjZvUxDi7534H4A18qV-tqyEkZrOzLw2H0tnVYsltUkrHuoCfywGGuHBdgmVSnrSdFs" alt="Gallery 1"/>
            </div>
            <div className="group overflow-hidden rounded-xl h-64 shadow-md">
              <img className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDoSBd4wfJqY8vQrd5SBVc_lkxvFegX-RSE6ov4u5748eADpY7HuT4vgVj4A4grNEQB88n85D4_I39SlrWHK-f6hxxjGcXoq_2ywLMfko48JIL4bmsqq9ed8zRJbVv5svTpGYROApP4bBm56XPO8JXyc2EgP7aZrUOUHlV9KYs8luYGpUUE_lpYIFwo5FSWNiHqJJBrCqef8F5nBhXxOV8qtZ54z9Q0-oPHk0hmOHBLWrV16WBGuoVlmDo_0H6v3Cc7eR1u2afWRT0" alt="Gallery 2"/>
            </div>
            <div className="group overflow-hidden rounded-xl h-64 shadow-md sm:col-span-2 lg:col-span-1">
              <div className="w-full h-full bg-cover bg-center group-hover:scale-110 transition-transform duration-700" style={{ backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuCVnCmNORaEE2bZKw5GH6GyJOsxC3GsWyhPjvukS08SwhlvG1pqliUgimYROphz7CHjHxU9T0UO1Wd_d07mweSId_qSrCYaNAvtJ0YNicd39k8ktuol-DAt-cRqG5pXvGzL0tHewDI3n_XfRnTWdIThn-i6TMtqrjHL723L1Iyg1rmGbUaFQbvuFGuKEEMpeQBwSR7jZV6e7h8ViJqnjwwIe-IxteWEubHf4A-dv7D3VAyWy7B0Ej0Whryo_HmoHtg6MSHE-2QuJto')" }}></div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Why Choose Us Section */}
      <section className="py-16 md:py-28 bg-white text-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#111c2d] tracking-tight">{t("homeContent.why_us.title")}</h2>
            <p className="text-[#747780] max-w-xl mx-auto text-base sm:text-lg">{t("homeContent.why_us.desc")}</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group cursor-pointer flex flex-col justify-between">
              <div className="relative h-64 sm:h-72 lg:h-80 overflow-hidden rounded-xl mb-4 shadow-md group-hover:shadow-xl transition-all">
                <img className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCowTXvdWucX96zRILYUXm5Y9BKkRQk8vWS4gpiPwQ7tYsqWE-MYSC4wcKC7i1aHN02F7gfTZKODHcFXHGEeQPV1gIJnxsYjRQL_PjyyMOhu64gJCbnFfMSCZFziuHfIoT74mU_UDwEk-o5mX-z_Dx3nREVyynDdSaKPXYoCrAMIT4Ex6Oy89LcN1NXR5WBO72ggKJNrE7Ih_NOSbUEenCRWshKRoMvENlfJMEFrHznksnapMGeKnnK9XAteaqmE-88nCe6tQyy1tka" alt={t("homeContent.why_us.global_net")}/>
                <div className={`absolute bottom-0 ${lang === 'ar' ? 'right-0' : 'left-0'} bg-[#00204f] text-white px-6 py-2.5 font-bold rounded-t-sm`}>{t("homeContent.why_us.global_net")}</div>
              </div>
              <p className="text-[15px] text-[#747780] leading-relaxed px-1">{t("homeContent.why_us.global_net_desc")}</p>
            </div>
            <div className="group cursor-pointer flex flex-col justify-between">
              <div className="relative h-64 sm:h-72 lg:h-80 overflow-hidden rounded-xl mb-4 shadow-md group-hover:shadow-xl transition-all">
                <img className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCIOiUD_p_MF1VYRABp2AXGtoPlMdviS5pEFtvS-UUNRlK2QZ8EqHpdCd8frYW6DLoGIj2ClyzoC5gJZBMxEZomG1bubP-oD1Re6966l-gxlB891esVBch-_u3WwzUoom0qP_BhzC0vIDAJZ7X2b0ubGIHpf0huehT1y7vnixjp55AjYwQydffECVDe7Mt_A-kgcnodD0YeQi9MWlUdb7iTso_Dy70n2e9AOlcSzMzNXSuq1pdvPYsarS6DSt5D-eXHeZXR3t0IoPWp" alt={t("homeContent.why_us.max_speed")}/>
                <div className={`absolute bottom-0 ${lang === 'ar' ? 'right-0' : 'left-0'} bg-[#00204f] text-white px-6 py-2.5 font-bold rounded-t-sm`}>{t("homeContent.why_us.max_speed")}</div>
              </div>
              <p className="text-[15px] text-[#747780] leading-relaxed px-1">{t("homeContent.why_us.max_speed_desc")}</p>
            </div>
            <div className="group cursor-pointer flex flex-col justify-between">
              <div className="relative h-64 sm:h-72 lg:h-80 overflow-hidden rounded-xl mb-4 shadow-md group-hover:shadow-xl transition-all">
                <img className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBDPqFbv362H9-s_Oi1t787xG35b_UMDWWyw8C1o_Yqjt10Hi-B_1K-ojKpK_WYg9QOqoNWY2DYskgn0vqz1FOOXd9qFBQnrG2aSbx7eztf-8zxfQhzZh-GyMKHSkeKC7EYKP0yUkPjOjlA6Qr0WUiPZUw-n2JaBEHS4Dtc_XZsbnOhSqp0gQD-X3WC-OxSpBfyYUXviy0TsfF6v0q1f8s-0i_u1C8ZRjUflZox1YLZFSlrJMiFxQgCQrVD3S-oKUhkCmP-xkIRxrQq" alt={t("homeContent.why_us.pro_team")}/>
                <div className={`absolute bottom-0 ${lang === 'ar' ? 'right-0' : 'left-0'} bg-[#00204f] text-white px-6 py-2.5 font-bold rounded-t-sm`}>{t("homeContent.why_us.pro_team")}</div>
              </div>
              <p className="text-[15px] text-[#747780] leading-relaxed px-1">{t("homeContent.why_us.pro_team_desc")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Container Showcase Section */}
      <section className="w-full bg-slate-50 px-4 sm:px-6 lg:px-8 xl:px-16 py-16 md:py-28 text-gray-900">
        <div className="max-w-7xl mx-auto">
          <div className={`max-w-3xl ${lang === 'ar' ? 'text-right' : 'text-left'}`}>
            <span className="inline-block px-4 py-1.5 bg-[#bb0014] text-white text-xs font-semibold tracking-widest uppercase mb-4">
              {t("homeContent.containers.badge")}
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-[#00204c] mb-4">
              {t("homeContent.containers.title")}
            </h2>
            <p className="text-base sm:text-lg font-normal text-[#44474f] leading-relaxed max-w-2xl">
              {t("homeContent.containers.description")}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 md:mt-16">
            <div className="bg-white group flex flex-col h-full rounded-xl border border-gray-100 shadow-sm hover:shadow-lg transition-all overflow-hidden">
              <div className="h-56 sm:h-64 w-full overflow-hidden">
                <img className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" src={cont1} alt={t("homeContent.containers.cards.open_top.title")} />
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-[#00204c] mb-2">{t("homeContent.containers.cards.open_top.title")}</h3>
                <p className="text-sm sm:text-base text-[#44474f] leading-relaxed">{t("homeContent.containers.cards.open_top.text")}</p>
              </div>
            </div>

            <div className="bg-white group flex flex-col h-full rounded-xl border border-gray-100 shadow-sm hover:shadow-lg transition-all border-t-4 border-t-[#bb0014] overflow-hidden">
              <div className="h-56 sm:h-64 w-full overflow-hidden">
                <img className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" src={cont2} alt={t("homeContent.containers.cards.container_20ft.title")} />
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-[#00204c] mb-2">{t("homeContent.containers.cards.container_20ft.title")}</h3>
                <p className="text-sm sm:text-base text-[#44474f] leading-relaxed">{t("homeContent.containers.cards.container_20ft.text")}</p>
              </div>
            </div>

            <div className="bg-white group flex flex-col h-full rounded-xl border border-gray-100 shadow-sm hover:shadow-lg transition-all overflow-hidden md:col-span-2 lg:col-span-1">
              <div className="h-56 sm:h-64 w-full overflow-hidden">
                <img className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" src={cont3} alt={t("homeContent.containers.cards.container_40ft.title")} />
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-[#00204c] mb-2">{t("homeContent.containers.cards.container_40ft.title")}</h3>
                <p className="text-sm sm:text-base text-[#44474f] leading-relaxed">{t("homeContent.containers.cards.container_40ft.text")}</p>
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-12">
            <button 
              className="bg-[#00204c] text-white text-xs font-bold py-4 px-10 tracking-[0.2em] uppercase rounded-lg hover:bg-[#bb0014] transition-all transform hover:scale-105 active:scale-95 duration-300 shadow-md"
              onClick={() => navigate('/container-sizes')}
            >
              {t("homeContent.containers.cta")}
            </button>
          </div>
        </div>
      </section>

      {/* 6. Services Section */}
      <section className="py-16 md:py-28 bg-white text-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-[#1d3c78] mb-4">{t("homeContent.services.title")}</h2>
            <div className="w-16 h-1 bg-[#ba0035] mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              { key: 'sea', tag: 'sea', img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDlYe-JfdmcXZCGiM_j6UVNsPE-7mIpsnst03-5NzfdGYnYe6lR-zgMtZX7MH76T6rb5buOSno2rjfmgUpa8O-L1SDDa9ddrBnQqn1dPTERcuhV-AkK2wDrnA4hUZA9kv77fTwOf2Mw1njivbrWtwMc8apD2-glRrf70wFw3PmxPMioIb7WAQcBlEBJyWfq8FL7X6rtHulPITBwDofBpiE-muL5mAuKIC9q8M46c8TXCg1R6PGz1KViEfGDGhT0ARyzrL6_PJy9g9J9' },
              { key: 'air', tag: 'air', img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDlYe-JfdmcXZCGiM_j6UVNsPE-7mIpsnst03-5NzfdGYnYe6lR-zgMtZX7MH76T6rb5buOSno2rjfmgUpa8O-L1SDDa9ddrBnQqn1dPTERcuhV-AkK2wDrnA4hUZA9kv77fTwOf2Mw1njivbrWtwMc8apD2-glRrf70wFw3PmxPMioIb7WAQcBlEBJyWfq8FL7X6rtHulPITBwDofBpiE-muL5mAuKIC9q8M46c8TXCg1R6PGz1KViEfGDGhT0ARyzrL6_PJy9g9J9' },
              { key: 'road', tag: 'road', img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuByCNc59KwyGQ0qzB3vh1HhR1YhJVkgWyPUKChARMPHiIrMyBuh8Dmjpt_Q7zmecV9dMOGd9wwRXnABHNG69Ykj7IMdDpXOonxc1SeRgFwKgdAroZ6X4LQJ5hD0GnL51gxRY-WirKJNHFZazD5itKw5Ilyh0hykQ24M_AaHcZa7SGhfnLgnDSC66tXqzTU2O8DhHkQwW8SXbqRGL5-DZFRT2zUbfANHOj5mB0yks36Pu0lcCwsDloPPDSACdysrGmFnhCXx4GURf8d0' },
              { key: 'customs', tag: 'customs', img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZI24iQHS9sYpiwghFN8dfmqbuv4AvmUODYpLurLLwJ0HsVdm6FyK-EIq6GZ_YzOYoY5QT0SmlF3H3CqjeRAq5hxlBQG1sQwdPF623H7351Hs3FxtppTTIlKKKnGmj03W9xH4apOvdm_XCHjjzU7ZvCViSN-dZ9p3sT1wmqvK4XD7yrkDltZuRJthIqUOR-0HyLbvqxAnDY4f2ccPa02lKo6-rBu5aYR6eeJ-wzTygrdYayJb1AYI-JXT7KfpMlXQWSVQVuG7-zyCa' },
              { key: 'supply', tag: 'supply', img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCwCd7yIh77Gaews8JixdYA96SUXl-d0UfoXeJzWIxlKl3buxpYYp_mXFQxZGR8gHpdD3O2tk1idMuoBFoGI9C7a-FJPs-2RtPcMyf_sITby4eswTko8MbUSshZc_8n61FlXMmwCTaPvyWHledJyXqC6GN01-NXqiEEUKM0_LPTvq6QGL4Ch1vQhwlIFK-g51VNJ0o8ZQxxsVKiaAwsknQZ_G0IZJaQgrg2yv85IuDliOTtosV_WvNy5F4T1t4_lab7qDoNYiBXu7gg' },
              { key: 'warehousing', tag: 'warehousing', img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuApuvRIoG-AQwAlg7KSQMOQRDT9-HIBT5asvgLjPG6f1obW_J_fnN9QlNhBT8csMXOdwqFOCfuATCRETwQCATnEWbyIkewxcM2krrYlOwwmFRcdC2Va5IJ8y3gjlRZD1zKa5d3NTzJ52to_XeMJvMDSlTFPxBN6pAEiCSZakHU8a8SftnIkBazsegJ7RX9-UwO3rSVOe9-FkzXNBFwbpo1WHYUS6fL1FDRC0Z62Ouuv_S84cNH9c1sl4BRJyAZGX9VOS2m-0-H1hPjR' },
            ].map((srv) => (
              <div key={srv.key} className="group relative h-[420px] sm:h-[480px] md:h-[500px] overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all">
                <img alt={srv.key} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" src={srv.img}/>
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent z-10"></div>
                <div className={`absolute inset-x-0 bottom-0 p-6 md:p-10 text-white z-20 ${lang === 'ar' ? 'text-right' : 'text-left'}`}>
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{t(`homeContent.services.${srv.key}`)}</h3>
                  <p className="text-white/80 text-sm md:text-base line-clamp-3 leading-relaxed">{t(`homeContent.services.${srv.tag}_desc`)}</p>
                  <div className="mt-6 w-12 h-[2px] bg-[#ffb3ac] group-hover:w-full transition-all duration-500"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7. Team Section */}
      <div className="py-8 bg-white">
        <MeetOurTeam />
      </div>

      {/* 8. Network Stats Section */}
      <section className="relative min-h-[50vh] md:h-[65vh] flex items-center justify-center overflow-hidden py-16 md:py-0" id="network">
        <div className="absolute inset-0 bg-cover bg-center brightness-[0.35]" style={{ backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuDuPS_H3YehLzJz5b_lH864vzU6EMI-F3KUcc2c0vLaVb1anlvY3toIWAP3R7_gHi-cJd0iY2WEFIbxbto89XALBVZxEpo7oEjB1uBtWBvBEl5UTsfoSNTU3_2einqynmXcOQyyEPkxpUIint6YVS0cizNl9Spljh3uz5XMgPYIo7jRHqz-DJItvYimuKDx1XS-Z4Q82ciB0Kx2fE7uk3ICuTKcvHBqa9mK2BpTIvSs4k-jj0gPctzSJ4nMlQMqoBZoGu93eEYlnpA')" }}></div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6 max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 tracking-tight">{t("homeContent.network.title")}</h2>
          <p className="text-sm sm:text-base md:text-lg max-w-3xl mx-auto opacity-90 mb-10 leading-relaxed">{t("homeContent.network.desc")}</p>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12 pt-4">
            <div className="text-center">
              <span className="block text-4xl sm:text-5xl md:text-6xl font-extrabold text-[#ba0035]">120+</span>
              <span className="text-xs uppercase tracking-wider font-semibold text-gray-300 mt-2 block">{t("homeContent.network.stat_countries")}</span>
            </div>
            <div className="text-center">
              <span className="block text-4xl sm:text-5xl md:text-6xl font-extrabold text-[#ba0035]">300+</span>
              <span className="text-xs uppercase tracking-wider font-semibold text-gray-300 mt-2 block">{t("homeContent.network.stat_offices")}</span>
            </div>
            <div className="text-center">
              <span className="block text-4xl sm:text-5xl md:text-6xl font-extrabold text-[#ba0035]">15K+</span>
              <span className="text-xs uppercase tracking-wider font-semibold text-gray-300 mt-2 block">{t("homeContent.network.stat_partners")}</span>
            </div>
          </div>
        </div>
      </section>

      {/* 9. Contact Section */}
      <section className="py-16 md:py-28 bg-[#eceef0] text-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
            <div className="bg-white p-6 sm:p-10 md:p-12 rounded-2xl shadow-xl flex flex-col justify-center">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#002875] mb-6 tracking-tight">{t("homeContent.contact.title")}</h2>
              <form className="space-y-5" onSubmit={(e) => e.preventDefault()}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="text-xs font-semibold text-[#444651]">{t("homeContent.contact.name_label")}</label>
                    <input className="w-full rounded-lg border-gray-200 bg-[#f2f4f6] p-3.5 text-sm focus:bg-white focus:border-[#002875] focus:ring-1 focus:ring-[#002875] transition-all" placeholder={t("homeContent.contact.name_placeholder")} type="text" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-semibold text-[#444651]">{t("homeContent.contact.email_label")}</label>
                    <input className="w-full rounded-lg border-gray-200 bg-[#f2f4f6] p-3.5 text-sm focus:bg-white focus:border-[#002875] focus:ring-1 focus:ring-[#002875] transition-all" placeholder="email@example.com" type="email" />
                  </div>
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-[#444651]">{t("homeContent.contact.service_label")}</label>
                  <select className="w-full rounded-lg border-gray-200 bg-[#f2f4f6] p-3.5 text-sm focus:bg-white focus:border-[#002875] focus:ring-1 focus:ring-[#002875] transition-all">
                    <option>{t("homeContent.services.sea")}</option>
                    <option>{t("homeContent.services.air")}</option>
                    <option>{t("homeContent.services.road")}</option>
                    <option>{t("homeContent.services.customs")}</option>
                    <option>{t("homeContent.services.warehousing")}</option>
                  </select>
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-[#444651]">{t("homeContent.contact.message_label")}</label>
                  <textarea className="w-full rounded-lg border-gray-200 bg-[#f2f4f6] p-3.5 text-sm focus:bg-white focus:border-[#002875] focus:ring-1 focus:ring-[#002875] transition-all" placeholder={t("homeContent.contact.message_placeholder")} rows="4"></textarea>
                </div>
                <button className="w-full bg-[#002875] text-white py-4 rounded-lg text-base font-bold hover:bg-[#234290] transition-colors shadow-md mt-2">{t("homeContent.contact.submit")}</button>
              </form>
            </div>

<div className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0,05)] transition-all duration-300 hover:shadow-[0_12px_30px_rgba(0,28,117,0.1)] hover:-translate-y-1 min-h-[450px] lg:min-h-full">
  
  {/* 1. قسم الصورة (العنصر البصري العلوي) */}
  <div className="relative h-48 sm:h-56 overflow-hidden">
    <img 
      className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" 
      src="https://lh3.googleusercontent.com/aida-public/AB6AXuDSpn3XSe2qdR6kOdMnpdLJVpDbdKbKsM2DFnt3X8dMncoo8xKl-84kpu-7w4GIa5AMsVymBKQoL3nHq1XhZDV-jz_iQc4Qpt-q4jZCFs_zi6Zj5uDyxycBZMm9b-h3O6e5f5teFopLAGTx6lBFXXemCDMjMZ_mgneBIqAAhiZRlBrfQFak-72buWah8ndKXXp73IqJ80ljnNRHwyF5SP18xQZQH6ZiAJ7mK8H4XNGmImujzN-hs1fyNc_7PevZH45tbIQrPFmaNacx" 
      alt={t("homeContent.contact.office_title")} 
    />
    {/* طبقة حماية لونية خفيفة متناسقة مع الهوية */}
    <div className="absolute inset-0 bg-gradient-to-t from-[#002875]/20 to-transparent" />
  </div>

  {/* 2. قسم المحتوى والبيانات (منظم ومريح للعين) */}
  <div className="flex-1 p-6 sm:p-8 flex flex-col justify-between bg-gradient-to-b from-white to-slate-50/50">
    
    {/* القائمة والروابط */}
    <div className="space-y-5">
      
      {/* العنوان - تم استبدال الأيقونة بـ MapPin من lucide */}
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#002875]/5 flex items-center justify-center text-[#002875]">
          <MapPin size={22} strokeWidth={2} className="select-none" />
        </div>
        <div className="space-y-0.5 pt-0.5"> {/* تعديل بسيط في التباعد الرأسي */}
          <h4 className="text-xs font-bold text-[#002875] uppercase tracking-wider opacity-70">
            {t("homeContent.contact.office_title")}
          </h4>
          <p className="text-sm sm:text-base text-slate-600 font-medium leading-relaxed">
            {t("homeContent.contact.office_address")}
          </p>
        </div>
      </div>

      {/* رقم الهاتف - تم استبدال الأيقونة بـ Phone من lucide */}
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#002875]/5 flex items-center justify-center text-[#002875]">
          <Phone size={20} strokeWidth={2.25} className="select-none" />
        </div>
        <div className="space-y-0.5">
          <h4 className="text-xs font-bold text-[#002875] uppercase tracking-wider opacity-70">الهاتف</h4>
          <a href="tel:+96611000000" className="block text-sm sm:text-base text-slate-700 font-semibold tracking-wide hover:text-[#002875] transition-colors" dir="ltr">
            +966 11 000 0000
          </a>
        </div>
      </div>

      {/* البريد الإلكتروني - تم استبدال الأيقونة بـ Mail من lucide */}
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#002875]/5 flex items-center justify-center text-[#002875]">
          <Mail size={22} strokeWidth={2} className="select-none" />
        </div>
        <div className="space-y-0.5">
          <h4 className="text-xs font-bold text-[#002875] uppercase tracking-wider opacity-70">البريد الإلكتروني</h4>
          <a href="mailto:info@megt-logistic.com" className="block text-sm sm:text-base text-slate-700 font-semibold hover:text-[#002875] transition-colors break-all">
            info@megt-logistic.com
          </a>
        </div>
      </div>

    </div>

    {/* 3. الجزء السفلي (السوشيال ميديا) */}
    <div className="mt-8 pt-5 border-t border-slate-100 flex items-center justify-center">
      
      <div className="flex items-center gap-2.5">
        <a href="https://www.facebook.com/share/1BF2qDEA9E/?mibextid=wwXIfr" target="_blank" className="w-9 h-9 flex items-center justify-center text-slate-400 bg-slate-50 border border-slate-100 rounded-xl transition-all duration-300 hover:bg-[#002875] hover:text-white hover:border-[#002875] hover:-translate-y-0.5" aria-label="Facebook">
          <FacebookIcon className="w-4.5 h-4.5 fill-current" />
        </a>
        <a href="https://www.instagram.com/p/DYAIyZRFX7X/?igsh=MTd5ZTVscWllOXI3NQ==" target="_blank" className="w-9 h-9 flex items-center justify-center text-slate-400 bg-slate-50 border border-slate-100 rounded-xl transition-all duration-300 hover:bg-[#002875] hover:text-white hover:border-[#002875] hover:-translate-y-0.5" aria-label="Instagram">
          <InstagramIcon className="w-4.5 h-4.5 fill-current" />
        </a>
        <a href="https://www.linkedin.com/posts/megt-logistics_airfreight-logisticssolutions-lebanon-activity-7457834579434057728-QBK_?utm_source=share&utm_medium=member_ios&rcm=ACoAAEeDLtUBxjv1EPrFQPfUqQCICOGEzNK5NKU" target="_blank" className="w-9 h-9 flex items-center justify-center text-slate-400 bg-slate-50 border border-slate-100 rounded-xl transition-all duration-300 hover:bg-[#002875] hover:text-white hover:border-[#002875] hover:-translate-y-0.5" aria-label="LinkedIn">
          <LinkedinIcon className="w-4.5 h-4.5 fill-current" />
        </a>
        <a href="https://x.com/megtlogistic?s=11" target="_blank" className="w-9 h-9 flex items-center justify-center text-slate-400 bg-slate-50 border border-slate-100 rounded-xl transition-all duration-300 hover:bg-[#002875] hover:text-white hover:border-[#002875] hover:-translate-y-0.5" aria-label="LinkedIn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16">
            <path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
          </svg>
        </a>
      </div>
    </div>

  </div>
</div>
          </div>
        </div>
      </section>

      {/* 10. Video Popup Modal */}
      {isVideoOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
          {/* الخلفية لإغلاق النافذة عند الضغط خارج الفيديو */}
          <div className="absolute inset-0" onClick={() => setIsVideoOpen(false)}></div>
          
          {/* حاوية الفيديو */}
          <div className="relative w-full max-w-4xl bg-black rounded-2xl overflow-hidden shadow-2xl border border-white/10 z-10 aspect-video">
            {/* زر الإغلاق */}
            <button 
              className="absolute top-4 right-4 z-20 bg-black/50 text-white p-2 rounded-full hover:bg-[#cd021b] transition-colors"
              onClick={() => setIsVideoOpen(false)}
            >
              <X className="w-6 h-6" />
            </button>
            
            {/* عنصر الفيديو */}
            <video 
              src={exploreVideo} 
              className="w-full h-full object-contain" 
              controls 
              autoPlay
              playsInline
            />
          </div>
        </div>
      )}

    </div>
  );
}